import { z } from 'zod';
import { dateField } from '@shared/schemas';
import { baseManagerSchema } from './IBaseManager';

// Schemas (source of truth) — pure validation, no transforms
export const managerSchema = baseManagerSchema.extend({
	dateCreated: dateField,
	dateDeleted: dateField.optional(),
});

// Types (derived from schemas)
export type IManager = z.infer<typeof managerSchema>;
